export const firebaseConfigProd = {
  apiKey: "AIzaSyDB_WCflqxrjoyXkDb3Hb-mdmzwhjt8jsc",
  authDomain: "petscape-production.firebaseapp.com",
  projectId: "petscape-production",
  storageBucket: "petscape-production.firebasestorage.app",
  messagingSenderId: "938508500846",
  appId: "1:938508500846:web:3038c75d7848cd291fcb7f",
  measurementId: "G-BYPS0FCDBN"
};